import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import classNames from "classnames";

import { TMappedBetSlip } from "@state/quick-play-store/MostPlayedTicketsStore";
import { QuickPlayPopupsTeams } from "@features/quick-play/mobile/common/QuickPlayPopupsTeams";
import { QuickPlayEventTime } from "../../common/QuickPlayEventTime";
import { EventOfferBettingType } from "../../common/EventOfferBettingType";

export const MostPlayedTicketsPopupBody = observer(
	function MostPlayedTicketsPopupBody(props: { betSlip: TMappedBetSlip }) {
		const t = useTranslation().t;
		return (
			<>
				<div className="row">
					<div className="col col-sml-6">
						<div className="card--mpt__box card--mpt__box--grow">
							<div className="card--mpt__label">
								{t(
									"QUICK_PLAY.MOST_PLAYED_TICKETS.PLACED_BETS"
								)}
							</div>
							<div className="card--mpt__value">
								<span
									className={classNames(
										"card--mpt__value__label",
										{
											"u-color--sent--success":
												props.betSlip
													.submitCountIndicator,
										}
									)}
								>
									{props.betSlip.submitCount}
								</span>

								{props.betSlip.submitCountIndicator && (
									<i className="card--mpt__value__icon" />
								)}
							</div>
						</div>
					</div>

					<div className="col col-sml-6">
						<div className="card--mpt__box card--mpt__box--grow">
							<div className="card--mpt__label">
								{t(
									"QUICK_PLAY.MOST_PLAYED_TICKETS.COMBINATION"
								)}
							</div>
							<div className="card--mpt__value">
								{props.betSlip.eventCount}x
							</div>
						</div>
					</div>
				</div>

				<div className="card card--qp card--qp--scroll card--mpt u-mar--top--tny">
					<div className="card__body card--qp__body card--mpt__body">
						{props.betSlip.betSlipOffers.map((betSlipOffer) => (
							<React.Fragment key={betSlipOffer.bettingOfferId}>
								<div
									key={
										"section--" +
										betSlipOffer.bettingOfferId
									}
									className="card--qp__section card--mpt__section"
								>
									<div className="card--qp__event card--mpt__event">
										<QuickPlayEventTime
											startTime={
												betSlipOffer.sportData.startTime
											}
											sportAbrv={
												betSlipOffer.sportData.sportAbrv
											}
										/>

										<div className="card--qp__match card--mpt__match">
											<QuickPlayPopupsTeams
												sportData={
													betSlipOffer.sportData
												}
												eventId={betSlipOffer.eventId}
											/>
										</div>
									</div>

									<div className="card--qp__offer card--mpt__offer">
										<div className="card--qp__item card--mpt__item">
											<EventOfferBettingType
												offer={betSlipOffer}
												isPopup
											/>

											<strong className="card--qp__odd card--mpt__odd">
												{/* Coefficient */}
												{betSlipOffer.value.toFixed(2)}
											</strong>
										</div>
									</div>
								</div>

								<div
									key={
										"divider--" +
										betSlipOffer.bettingOfferId
									}
									className="card--mpt__divider"
								/>
							</React.Fragment>
						))}
					</div>
				</div>
			</>
		);
	}
);
